import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTenderProductComponent } from './add-tender-product.component';
import { NgZorroAntdModule } from 'src/app/modules/nz-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroIconModule } from 'src/app/modules/nz-icon-antd.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
	declarations: [
		AddTenderProductComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgZorroIconModule,
		TranslateModule,
		NgZorroAntdModule
	],
	exports: [AddTenderProductComponent]
})

export class AddTenderProductModule { }
